import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import Root from 'containers/Root';
import storeConfig from 'store';

import './index.module.scss';

const rootElement = document.getElementById('root');
rootElement.style.height = '100%';
rootElement.style.position = 'relative';
rootElement.style.width = '100%';

const { store, ...rest } = storeConfig;

const root = createRoot(rootElement);
root.render(
    <Provider store={store}>
        <Root {...rest} />
    </Provider>
);
